import faIR from './langs/fa-ir';
import enUS from './langs/en-us';

const locales: Record<App.I18n.LangType, App.I18n.Schema> = {
  'fa-IR': faIR,
  'en-US': enUS
};

export default locales;
